import script from "./school.vue?vue&type=script&setup=true&lang=js"
export * from "./school.vue?vue&type=script&setup=true&lang=js"

import "./school.vue?vue&type=style&index=0&id=e9f1cd50&lang=less"
script.__scopeId = "data-v-e9f1cd50"

export default script